import Link from 'antd/es/typography/Link';
import { Link as RouterLink } from 'react-router-dom';

import type { FC } from 'react';

export const LegalInformation: FC = () => (
  <div className="LegalInformation">
    <h4>Правовая информация</h4>
    <ul>
      <li>
        <Link
          href="https://byhelp.ru/politics"
          target="_blank"
          rel="noopener noreferrer"
        >
          Политика конфиденциальности
        </Link>
      </li>
      <li>
        <RouterLink to="https://byhelp.ru/user-agreement">
          Пользовательское соглашение
        </RouterLink>
      </li>
    </ul>
  </div>
);
